import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    showFilters: false,
    darkMode: false,
    filters: {
      type: "",
      client: "",
      industry: "",
      year: ""
    },
    search: "",
    orderby: "projectDate"
  },
  getters: {
    filtersCount(state) {
      return Object.keys(state.filters)
        .filter(k => state.filters[k]?.length > 0)
        .length;
    }
  },
  mutations: {
    setShowFilters(state, showFilters) {
      state.showFilters = showFilters;
    },
    setDarkMode(state, darkMode) {
      state.darkMode = darkMode;
    },
    setFilters(state, filters) {
      state.filters = filters;
    },
    setSearch(state, search) {
      state.search = search;
    },
    setOrderBy(state, orderby) {
      state.orderby = orderby;
    }
  },
  actions: {
    initialize({ commit, state, getters, dispatch }) {
      const strDarkMode = localStorage.getItem("clue.concepts.darkMode");
      if (strDarkMode && strDarkMode === "true") {
        commit("setDarkMode", true);
      }
    },
    toggleFilters({state, commit}) {
      commit("setShowFilters", !state.showFilters);
      return state.showFilters;
    },
    toggleDarkMode({state, commit}) {
      commit("setDarkMode", !state.darkMode);
      // presists darkMode on localStorage
      localStorage.setItem("clue.concepts.darkMode", state.darkMode ? "true" : "false");
      return state.darkMode;
    },
    changeFilters({commit}, filters) {
      commit("setFilters", filters)
    },
    changeSearch({commit}, search) {
      commit("setSearch", search)
    },
    changeOrderBy({commit}, orderby) {
      commit("setOrderBy", orderby)
    }
  },
  modules: {
  }
})
